import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=2373352a&"
import script from "./delivery.vue?vue&type=script&lang=js&"
export * from "./delivery.vue?vue&type=script&lang=js&"
import style0 from "./delivery.vue?vue&type=style&index=0&id=2373352a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/Loading.vue').default})
